<template>
  <div id="app" class="w-full h-full relative">
    <!-- Main Application -->
    <router-view />
  </div>
</template>
